
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AgentRuntimeForm } from "./AgentRuntimeForm";
import { AgentRuntimeResults } from "./AgentRuntimeResults";
import { Agent } from "@/models/agent";
import { AgentDefinition, AgentExecutionResponse } from "@/models/agent-runtime";
import { AgentRuntimeHistory } from "./AgentRuntimeHistory";

interface AgentRuntimeContentProps {
  agent: Agent;
  agentRuntimeDef: AgentDefinition;
  setResult: (result: AgentExecutionResponse | null) => void;
  result: AgentExecutionResponse | null;
  executionHistory?: AgentExecutionResponse[];
  onBack: () => void;
}

export function AgentRuntimeContent({
  agent,
  agentRuntimeDef,
  setResult,
  result,
  executionHistory = [],
  onBack
}: AgentRuntimeContentProps) {
  const [activeTab, setActiveTab] = useState("run");
  
  return (
    <div className="container mx-auto p-4 md:p-6">
      <Button variant="outline" className="mb-6" onClick={onBack}>
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
      
      <div className="mb-6">
        <h1 className="text-3xl font-bold">{agent?.name || "Run Agent"}</h1>
        <p className="text-muted-foreground mt-1">
          {agent?.description || "Execute agent with your inputs"}
        </p>
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="run">Execute</TabsTrigger>
          <TabsTrigger value="history">Execution History</TabsTrigger>
        </TabsList>
        
        <TabsContent value="run" className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <AgentRuntimeForm
              agent={agentRuntimeDef}
              onExecutionComplete={setResult}
            />
            
            <AgentRuntimeResults result={result} />
          </div>
        </TabsContent>
        
        <TabsContent value="history">
          <AgentRuntimeHistory history={executionHistory} onSelectResult={setResult} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
